module.exports = __webpack_public_path__ + "static/media/error.bdf06b0f.svg";